export default class InventaireStocksMouvementController {
	static $inject = ['$stateParams', 'StocksCommunicationService', 'StocksService', 'notification', 'ModalService', '$uibModal', 'moment'];

	constructor($stateParams, StocksCommunicationService, StocksService, notification, ModalService, $uibModal, moment) {
		this.$stateParams = $stateParams;
		this.StocksCommunicationService = StocksCommunicationService;
		this.StocksService = StocksService;
		this.notification = notification;
		this.ModalService = ModalService;
		this.$uibModal = $uibModal;
		this.moment = moment;
	}

	async $onInit() {
		this.initialDateLevee = this.inventaire.dateLevee;
	}

	annuler() {
		this.inventaire.dateLevee = this.initialDateLevee;
		this.modalInstance.close(false);
	}

	async confirmer() {
		if (this.inventaire.dateLevee) {
			const res = await this.createMouvement();
			if (res != undefined) {
				this.notification.success('STOCKS.INVENTAIRELIG.MOUVEMENT_CREATED');
				this.modalInstance.close(true);
			}
		} else {
			this.notification.error('STOCKS.DATE_EMPTY');
		}
	}

	async createMouvement() {
		this.startLoading();
		try {
			return await this.StocksService.createMouvement(this.inventaire);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}
}
